import { MCP_ID_PREFIX } from "./mcp-prefix-constants";
import { parseToolOutput } from "./parse-tool-output";
import { labelOnly } from "../../label-only";
import { toolInput } from "../../tool-input";
import type { ToolActivity } from "../../tool-activity";

/** `mcp/<serverId>/<tool>` reads as the tool, plus the server name once the result carries it. */
export function describeToolExecute(
  record: Record<string, unknown>,
  output: unknown,
): ToolActivity {
  const target = toolInput.str(record.tool);
  if (!target) return labelOnly("Ran an integration tool");
  if (!target.startsWith(MCP_ID_PREFIX)) {
    return labelOnly(`Ran ${toolInput.truncate(target, 60)}`);
  }
  const rest = target.slice(MCP_ID_PREFIX.length);
  const tool = rest.slice(rest.indexOf("/") + 1);
  const result = parseToolOutput(output);
  const server = toolInput.str(result?.server);
  const name = toolInput.truncate(tool, 40);
  const label = server ? `${name} · ${toolInput.truncate(server, 20)}` : name;
  if (result?.reason === "mcp_disconnected") {
    return labelOnly(`${label} failed: MCP disconnected, sign in again`);
  }
  return labelOnly(`Ran ${label}`);
}
